export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
  value: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'GUIDE DES ANALYSES DE SOL : LIRE ET INTERPRÉTER UN BULLETIN D’ANALYSE™',
    subtitle: 'Du bulletin du laboratoire à une lecture claire',
    body: 'pH, CEC, matière organique, éléments échangeables, rapports entre cations : comment lire chaque ligne d’un bulletin, repérer ce qui compte et relier les résultats à ce que vous observez sur la parcelle. Valeurs toujours indicatives, selon le laboratoire et la culture.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 2',
    title: 'FICHES DE TERRAIN IMPRIMABLES : OBSERVATION, PRÉLÈVEMENT ET SUIVI DES PARCELLES™',
    subtitle: 'Chaque visite documentée, de l’observation au suivi',
    body: 'Fiches d’observation, fiches de prélèvement sol et foliaire, tableaux de suivi par parcelle et modèles de compte rendu : prêtes à imprimer ou à remplir sur tablette.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 3',
    title: 'GUIDE DES CARENCES VS MALADIES : NE PLUS CONFONDRE LES SYMPTÔMES™',
    subtitle: 'Carence, maladie, ravageur ou stress ?',
    body: 'Les symptômes qui se ressemblent, les indices qui les distinguent (répartition, organe atteint, évolution) et la vérification qui permet de trancher avant d’intervenir.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 4',
    title: 'CALCULS DE FERTILISATION SIMPLIFIÉS : UNITÉS, DOSES ET CONVERSIONS™',
    subtitle: 'Les calculs du quotidien, sans erreur d’unité',
    body: 'Unités fertilisantes, conversions oxydes / éléments, passage du kg/ha à la dose par surface, concentrations et dilutions : la méthode de calcul pas à pas, à adapter à chaque situation et à la réglementation locale.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 5',
    title: 'CAHIER DE CAS PRATIQUES : 40 DIAGNOSTICS NUTRITIONNELS ANALYSÉS PAS À PAS™',
    subtitle: 'S’entraîner à raisonner comme un technicien de terrain',
    body: '40 cas pratiques fictifs à difficulté progressive, des grandes cultures à la serre, chacun construit sur OBSERVER › COMPARER › INVESTIGUER › ANALYSER › ÉVALUER › AGIR avec une résolution expliquée.',
    value: '15 €',
  },
]
